export const TABLET_BREAKPOINT = 768;
export const PHONE_BREAKPOINT = 480;

export const DESKTOP = 'desktop';
export const TABLET = 'tablet';
export const PHONE = 'phone';

export const DEVICE_BREAKPOINTS_MAP = {
    [DESKTOP]: undefined,
    [TABLET]: TABLET_BREAKPOINT,
    [PHONE]: PHONE_BREAKPOINT,
};

export const BREAKPOINT_HEIGHTS = {
    [TABLET_BREAKPOINT]: 1024,
    [PHONE_BREAKPOINT]: 860,
};
